export const generalErrorMessage = "ups, coś poszło nie tak";
